import {MdiIconString} from "nuxt-mdi/dist/runtime/components/MdiIcon";

export const sharePlatform: Record<string, { url: string, icon: MdiIconString, color: string, aria: string, tabindex: number }> = {
  facebook: {
    url: 'https://www.facebook.com/sharer.php?u=',
    icon: 'mdiFacebook',
    color: '#395693',
    aria: 'facebook',
    tabindex: 4
  },
  whatsapp: {
    url: 'https://api.whatsapp.com/send?text=',
    icon: 'mdiWhatsapp',
    color: '#00E676',
    aria: 'whatsapp',
    tabindex: 5
  },
}